var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDownGray6Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "6px",
    viewBox: "0 0 8 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "069C88E3-A0BA-4AE9-B1D4-E47A4B267982_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Navigation",
    transform: "translate(-1398.000000, -94.000000)",
    stroke: "#E7E7E7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(1218.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Down_Gray-6px",
    points: "181 23 184 26 187 23"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownGray6Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Down_Gray-6px.74ebfef6725604030f5b403ffead2e58.svg";
export { ForwardRef as ReactComponent };